module.exports = __webpack_public_path__ + "static/media/cev.1cbf0c58.jpg";